import React from "react";
import { createTheme, ThemeProvider } from "@mui/material";
import { BrowserRouter } from "react-router-dom";

import Main from "./Main";
import {
  PENN_DOT_BLUE,
  PENN_DOT_BLUE_DARK,
  PENN_DOT_BLUE_LIGHT,
  PENN_DOT_GREEN,
  PENN_DOT_GREEN_DARK,
  PENN_DOT_GREEN_LIGHT,
} from "./constants/styleConstants";

function App() {
  const theme = createTheme({
    palette: {
      primary: {
        main: PENN_DOT_BLUE,
        light: PENN_DOT_BLUE_LIGHT,
        dark: PENN_DOT_BLUE_DARK,
      },
      secondary: {
        main: PENN_DOT_GREEN,
        light: PENN_DOT_GREEN_LIGHT,
        dark: PENN_DOT_GREEN_DARK,
      },
    },
  });
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <ThemeProvider theme={theme}>
        <Main />
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
